module.exports = __webpack_public_path__ + "static/media/vapour-img6.22ee2afb.png";